const pluralizeWord = (word) => {
  if (/ção$/i.test(word)) return word.replace(/ção$/i, 'ções')
  if (/ão$/i.test(word)) return word.replace(/ão$/i, 'ões')
  if (/[rz]$/i.test(word)) return `${word}es`
  if (/m$/i.test(word)) return word.replace(/m$/i, 'ns')
  if (/s$/i.test(word)) return word
  return `${word}s`
}

export const pluralizeServiceName = (name, count) => {
  if (count === 1) return name

  const [firstWord, ...rest] = name.split(' ')
  return [pluralizeWord(firstWord), ...rest].join(' ')
}
